// Pragmatic CSS gradient parser: handles the two shapes actually present in
// THEME_COLOR_KEYS (`linear-gradient(<deg>deg, <stops>)` and
// `radial-gradient(<shape>, <stops>)`) rather than the full CSS gradient
// grammar (repeating-gradient, conic-gradient, keyword angles, multiple
// color spaces, etc.) - anything outside that returns null, and the caller
// falls back to plain text editing rather than guessing.

// Splits a comma-separated stop list while respecting paren depth, since a
// stop's own color (rgb(a, b, c)) contains commas that aren't separators.
function splitStops(stopsStr) {
  const stops = [];
  let depth = 0;
  let current = '';
  for (const ch of stopsStr) {
    if (ch === '(') depth++;
    if (ch === ')') depth--;
    if (ch === ',' && depth === 0) {
      stops.push(current.trim());
      current = '';
    } else {
      current += ch;
    }
  }
  if (current.trim()) stops.push(current.trim());

  return stops.map((s) => {
    const match = s.match(/^(.+?)\s+([\d.]+)%$/);
    if (match) return { color: match[1].trim(), position: Number(match[2]) };
    return { color: s.trim(), position: null };
  });
}

const LINEAR_RE = /^linear-gradient\(\s*([\d.]+)deg\s*,\s*(.+)\)$/i;
const RADIAL_RE = /^radial-gradient\(\s*(circle|ellipse)\s*,\s*(.+)\)$/i;

export function parseGradient(css) {
  if (!css) return null;
  const trimmed = css.trim();

  let match = trimmed.match(LINEAR_RE);
  if (match) {
    return { type: 'linear', angle: Number(match[1]), stops: splitStops(match[2]) };
  }

  match = trimmed.match(RADIAL_RE);
  if (match) {
    return { type: 'radial', shape: match[1], stops: splitStops(match[2]) };
  }

  return null;
}

export function formatGradient(gradient) {
  const stopsStr = gradient.stops
    .map((s) => (s.position != null ? `${s.color} ${s.position}%` : s.color))
    .join(', ');
  if (gradient.type === 'radial') {
    return `radial-gradient(${gradient.shape}, ${stopsStr})`;
  }
  return `linear-gradient(${gradient.angle}deg, ${stopsStr})`;
}
